import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`

@font-face {
  font-family: "Montserrat";
  src: url("../assets/fonts/Montserrat/Montserrat-Regular.ttf");
  font-weight: 400;
}

@font-face {
  font-family: "Merriweather";
  src: url("../assets/fonts/Merriweather-Regular.ttf");
  font-weight: 400;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html {
  font-size: 10px;

  @media screen and (max-width: 400px) {
    font-size: 8px;
  }
}

body {
  font-family: "Montserrat", "Arial", sans-serif;
}

a {
  text-decoration: none;
}

h1,
h3 {
  color: hsl(132, 4%, 25%);

}

h1 {
  font-size: 5rem;
}

h3 {
  font-size: 3rem;
}
`;
